import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {

    SEATINGTYPE_ADD_ACTION_TYPE,
    SEATINGTYPE_DELETE_ACTION_TYPE,
    SEATINGTYPE_DETAIL_ACTION_TYPE,
    SEATINGTYPE_LIST_ACTION_TYPE,
  headers, seatingTypeAddUrl, seatingTypeDeleteUrl, seatingTypeDetailUrl, seatingTypeListUrl
} from "../../utils/constants";
import moment from "moment";

export const seatingType_list_action = (SittingTypeName, StatusID) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
      SittingTypeName: SittingTypeName.toString().trim(),
     StatusID: StatusID==1?1:StatusID==0?0:null,
    };
    const params = {
      userId:mapdata.userId==""?null:mapdata.userId,
      SittingTypeName: mapdata.SittingTypeName == "" ? null : mapdata.SittingTypeName,
       StatusID: mapdata.StatusID,
    };
    console.log("seating mapdata...", mapdata);
    const res = await axiosGet(seatingTypeListUrl, params,headers);
    console.log("seating", res);
    dispatch({
      type: SEATINGTYPE_LIST_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};

  export const seatingType_detail_action = (SittingTypeID) => async (dispatch) => {
    try {
      const params = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        SittingTypeID: SittingTypeID,
      };
      console.log("seating detail mapdata...", params);
      const res = await axiosGet(seatingTypeDetailUrl, params,headers);
      console.log("detailsseating", res);
      dispatch({
        type: SEATINGTYPE_DETAIL_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const seatingType_add_action = (
  SittingTypeID,
  SittingTypeName,
  StatusID
) => async (dispatch) => {
  try {
    const mapdata = {
      userId:  sessionStorage.getItem("userId") == "" ||
      sessionStorage.getItem("userId") == null
        ? ""
        : sessionStorage.getItem("userId"),
      SittingTypeID: SittingTypeID ? SittingTypeID.toString().trim() : null,
      SittingTypeName: SittingTypeName.toString().trim(),
      StatusID: StatusID?StatusID:0,
    };
    console.log("seating add mapdata...", mapdata);

    const res = await axiosPost(seatingTypeAddUrl, mapdata, headers);
    dispatch({
      type: SEATINGTYPE_ADD_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};


export const seatingType_delete_action =(SittingTypeID) => async (dispatch) => {
    try {
      const mapdata = {
        userId:  sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
        SittingTypeID: SittingTypeID ? SittingTypeID.toString().trim() : "",
      };

      const res = await axiosGet(seatingTypeDeleteUrl, mapdata,headers);
      dispatch({
        type: SEATINGTYPE_DELETE_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
